"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailClick = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15,17 L15,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.44771525 4.44771525,6 5,6 L19,6 C19.5522847,6 20,6.44771525 20,7 L20,11 L19,11 L19,7.65853889 L12.9761871,12.8218071 C12.4144525,13.3032939 11.5855475,13.3032939 11.0238129,12.8218071 L5,7.65853889 L5,17 L15,17 Z M5.76829537,7 L11.6746043,12.0625505 C11.8618492,12.2230461 12.1381508,12.2230461 12.3253957,12.0625505 L18.2317046,7 L5.76829537,7 Z M20.2601209,18 L21.2611413,20.3213364 C21.3704875,20.5749069 21.2535705,20.8691091 21,20.9784553 C20.7464295,21.0878015 20.4522273,20.9708845 20.3428811,20.717314 L19.3326014,18.3745054 L17.8535534,19.8535534 C17.6582912,20.0488155 17.3417088,20.0488155 17.1464466,19.8535534 C17.0526784,19.7597852 17,19.6326082 17,19.5 L17,12.5 C17,12.2238576 17.2238576,12 17.5,12 C17.6326082,12 17.7597852,12.0526784 17.8535534,12.1464466 L22.8706245,17.1635177 C23.0619814,17.3548746 23.0619814,17.6651254 22.8706245,17.8564823 C22.7787316,17.9483751 22.6540982,18 22.5241421,18 L20.2601209,18 Z M18,18.2928932 L19.2928932,17 L21.2928932,17 L18,13.7071068 L18,18.2928932 Z" })));
};
EmailClick.displayName = 'EmailClick';
exports.default = EmailClick;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailClick.js.map